import Schedules from "./schedule/Schedules";
import {HCROUTES} from "../shared/constants/Constant";

const scheduleRoutes = [
    {
        path: '/danh-sach-lich',
        name: HCROUTES.schedule,
        component: Schedules,
        meta: {
            title: 'Danh sách lịch'
        }
    }
];

export default scheduleRoutes;
